import React, { useEffect, useState } from "react";
import { waitForI18n } from "../i18n";

const I18nProvider = ({ children }) => {
  const [isReady, setIsReady] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const initializeI18n = async () => {
      try {
        // console.log("🔄 Initialisation i18n...");
        await waitForI18n();
        // console.log("✅ i18n initialisé avec succès");
        setIsReady(true);
      } catch (err) {
        console.error("❌ Erreur lors de l'initialisation i18n:", err);
        setError(err);
      }
    };

    initializeI18n();
  }, []);

  if (error) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-background">
        <div className="text-center">
          <div className="mb-4 text-4xl text-red-500">❌</div>
          <h2 className="mb-2 text-xl font-bold text-red-700">
            Erreur d'initialisation i18n
          </h2>
          <p className="text-red-600">{error.message}</p>
        </div>
      </div>
    );
  }

  if (!isReady) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-background">
        <div className="text-center">
          <div className="mx-auto mb-4 w-12 h-12 rounded-full border-b-2 animate-spin border-accent-700"></div>
          <p className="text-accent-700">Chargement des traductions...</p>
        </div>
      </div>
    );
  }

  return children;
};

export default I18nProvider;
